import { Button } from "antd";
import styled from "styled-components";

export const RegisterButton = styled(Button)`
  height: 40px;
  width: 140px;
`;

export const CancelButton = styled(Button)`
  height: 40px;
  width: 140px;
  border: 1px solid ${(props) => props.theme.colors.manatee};
`;

export const CloseDrawer = styled.span`
  .closeIcon > svg {
    color: ${(props) => props.theme["@input-border-color"]} !important;
    cursor: pointer !important;
    :hover {
      color: ${(props) => props.theme.colors.text} !important;
    }
  }
`;

export const HeaderAttendanceContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 30px;
  height: 48px;
  width: 100%;
  min-width: 0;
`;

export const SearchFieldContainer = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
`;
